import { AiOutlineSave } from 'react-icons/ai';
import { Button } from '../../../../../../../components/button/button';
import { Container } from '../../../../../../../components/container/container';
import { Input } from '../../../../../../../components/input/input';
import { PasswordInput } from '../../../../../../../components/input/password-input';
import { HasAccess } from '../../../../../../../features/has-access/has-access';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import s from './profile-security.module.css';
import { useProfileSecurity } from './use-profile-security';

export const ProfileSecurity = () => {
  const {
    t,
    changePasswordData,
    handleUpdateChangePasswordData,
    handleSavePassword,
    isChangingPassword,
    toggleIsEdit,
    isEdit,
  } = useProfileSecurity();
  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('profile', ['write']);
  const disabled = !isEdit || isNotAllowed;

  return (
    <div className={s.feature}>
      <div className={s.inputs}>
        <Container label={t('Логин')} required>
          <Input
            size="lg"
            name="login"
            value={changePasswordData?.login}
            disabled={disabled}
            onChange={(e) => handleUpdateChangePasswordData({ login: e.currentTarget.value })}
          />
        </Container>
        <Container label={t('Старый Пароль')} required>
          <PasswordInput
            size="lg"
            disabled={disabled}
            value={changePasswordData?.old_password}
            onChange={(e) =>
              handleUpdateChangePasswordData({ old_password: e.currentTarget.value })
            }
            name="newPassword"
            autoComplete="off"
          />
        </Container>
        <Container label={t('Новый Пароль')} required>
          <PasswordInput
            size="lg"
            disabled={disabled}
            value={changePasswordData?.password}
            onChange={(e) => handleUpdateChangePasswordData({ password: e.currentTarget.value })}
            name="password"
            autoComplete="off"
          />
        </Container>
        <Container label={t('Повторите пароль')} required>
          <PasswordInput
            size="lg"
            disabled={disabled}
            value={changePasswordData?.repeatPassword}
            onChange={(e) =>
              handleUpdateChangePasswordData({ repeatPassword: e.currentTarget.value })
            }
            name="repeatPassword"
            autoComplete="off"
          />
        </Container>
      </div>
      <HasAccess service="profile" permissions={['write']}>
        <div className={s.controls}>
          <Button
            className={s.submit}
            disabled={disabled || isChangingPassword}
            onClick={handleSavePassword}
          >
            <AiOutlineSave />
            {t('Сохранить')}
          </Button>
          <Button variant="ghost" onClick={toggleIsEdit} className={s.edit}>
            {isEdit ? t('Отмена') : t('Изменить пароль')}
          </Button>
        </div>
      </HasAccess>
    </div>
  );
};
